
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"24","viewBox":"0 0 21 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.449219 20.2753C0.449219 17.1227 3.00498 14.5669 6.15767 14.5669H15.2912C18.4439 14.5669 20.9997 17.1227 20.9997 20.2753V22.5587C20.9997 23.1893 20.4885 23.7004 19.858 23.7004C19.2274 23.7004 18.7163 23.1893 18.7163 22.5587V20.2753C18.7163 18.3837 17.1828 16.8503 15.2912 16.8503H6.15767C4.26606 16.8503 2.7326 18.3837 2.7326 20.2753V22.5587C2.7326 23.1893 2.22145 23.7004 1.59091 23.7004C0.960371 23.7004 0.449219 23.1893 0.449219 22.5587V20.2753Z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.01562 6.57515C5.01562 3.42246 7.57139 0.866699 10.7241 0.866699C13.8768 0.866699 16.4325 3.42246 16.4325 6.57515C16.4325 9.72785 13.8768 12.2836 10.7241 12.2836C7.57139 12.2836 5.01562 9.72785 5.01562 6.57515ZM10.7241 3.15008C8.83246 3.15008 7.29901 4.68354 7.29901 6.57515C7.29901 8.46677 8.83246 10.0002 10.7241 10.0002C12.6157 10.0002 14.1492 8.46677 14.1492 6.57515C14.1492 4.68354 12.6157 3.15008 10.7241 3.15008Z"}})])
          )
        }
      }
    